<template>
  <div class="offer-create">
    <b-container class="pt-4">

      <OfferParams
        @loaded="(results) => paramsLoaded(results)"
        v-if="!hashParams.seminarDateId"
      />
      <OfferParamsOpenSeminar
        @loaded="(results) => paramsLoaded(results)"
        v-else
      />

      <h4 class="text-left mb-3 mt-3 check-heading">
        <span
          style=""
          :class="{ 'text-danger': errors && errors.length > 0 }"
        >
          <i
            class="material-icons"
            v-if="errors && errors.length === 0"
          >check_circle</i>
          <i
            class="material-icons"
            v-if="errors && errors.length > 0"
          >cancel</i>
        </span>
        Angebot erstellen
      </h4>

      <b-alert
        show
        variant="danger"
        v-if="errors && errors.length > 0"
      >
        <h6>Das Angebot kann aus folgenden Gründen nicht erstellt werden:</h6>
        <ul>
          <li
            v-for="(error, index) in errors"
            :key="index"
          >{{ error }}</li>
        </ul>
      </b-alert>

      <!-- If Valid -->
      <div v-if="errors && errors.length === 0">

        <!-- New Offer -->
        <b-btn
          v-if="!existingOffer"
          class="mr-2"
          variant="success"
          @click="createOffer()"
        >
          <i class="material-icons">save</i> Neues Angebot erstellen
        </b-btn>

        <!-- Existing Offer: Same VC diffrent Offer-ID -->
        <div v-if="existingOffer && existingOffer.hash !== params.hash && existingOffer.vcId !== 'Offene Angebote'">
          <b-alert
            show
            variant="
          info"
          >
            <h6>Es gibt noch ein kleines Problem:</h6>
            Ein Angebot zur Verkaufchance mit der ID "<b>{{ existingOffer.vcId }}</b>" existiert schon.
          </b-alert>
          <b-btn
            class="mr-2"
            variant="success"
            @click="createOffer()"
          >
            <i class="material-icons">add</i> Weiters Angebot hinzufügen
          </b-btn>
          <b-btn
            class="mr-2"
            variant="primary"
            @click="createFromCopy()"
          >
            <i class="material-icons">merge</i> Angebote zusammenführen
          </b-btn>
        </div>

        <!-- Existing Offer: Same Offer-ID not completed yet -->
        <div v-if="existingOffer && existingOffer.hash === params.hash && !existingOffer.completed">
          <b-alert
            show
            variant="warning"
          >
            <h6>Es gibt noch ein kleines Problem:</h6>
            Ein Angebot mit der ID "<b>{{ existingOffer.hash }}</b>" existiert schon.
          </b-alert>
          <b-btn
            class="mr-2"
            variant="danger"
            @click="resetOffer()"
          >
            <i class="material-icons">save_as</i> Angebot überschreiben
          </b-btn>
          <b-btn
            class="mr-2"
            variant="primary"
            @click="overwriteFromCopy()"
          >
            <i class="material-icons">merge</i> Angebot zusammenführen
          </b-btn>
        </div>

        <!-- Existing Offer: Same Offer-ID completed (sent to the customer) -->
        <div v-if="existingOffer && existingOffer.hash === params.hash && existingOffer.completed">
          <b-alert
            show
            variant="danger"
          >
            <h6>Das Angebot kann aus folgenden Gründen nicht erstellt werden:</h6>
            <ul>
              <li>
                Das Angebot mit der ID "<b>{{ existingOffer.hash }}</b>" wurde bereits verschickt und kann darum
                nichtmehr
                verändert werden.
              </li>
              <li>
                Bitte erstelle ein neues Angebot zu dieser Verkaufschance oder eine neue Verkaufschance in Combit
              </li>
            </ul>
          </b-alert>
        </div>

      </div>

      <b-card class="mt-3 mb-3">
        <a
          href="#"
          @click.prevent="showDebug = !showDebug"
          class="debug-link"
        >
          <h6
            class="debug-heading m-0"
            :class="{ 'text-muted': !showDebug }"
          >
            <i class="material-icons">bug_report</i> Debug Info <small v-if="showDebug">ausblenden</small><small
              v-else>anzeigen</small>
          </h6>
        </a>
        <pre v-if="debug && showDebug">
          {{ debug }}
        </pre>
      </b-card>

    </b-container>

  </div>
</template>


<script>

import OfferParams from '../components/OfferParams.vue';
import OfferParamsOpenSeminar from '../components/OfferParamsOpenSeminar.vue';
import axios from 'axios';
import Config from '../misc/Config';
import { mapGetters, mapActions, mapMutations } from 'vuex';


export default {
  name: 'OfferCreate',
  components: { OfferParams, OfferParamsOpenSeminar },
  data: function () {
    return {
      errors: null,
      params: null,
      existingOffer: null,
      debug: null,
      showDebug: false,
    };
  },
  computed: {
    ...mapGetters([
      'offer',
      'existingOfferByVcId',
      'existingOfferByHash',
      'hasHashParams',
      'hashParams',
    ])
  },
  methods: {
    ...mapActions([
      'saveOffer',
      'mergeOffers',
      'overwriteOffer',
      'logOfferRequest',
    ]),
    ...mapMutations([
      'offerSet', //@todo set params on save not in vuex state
      'offerClear', //@todo s.o.
      'clearHashParams'
    ]),
    async paramsLoaded(result) {
      this.errors = result.valid ? [] : result.errors.map(err => err.message);
      this.debug = result;
      if (this.errors.length === 0) {
        this.params = result.values;
        await this.checkExisting(this.params.vcId, this.params.hash)
      }
      this.logOfferRequest({
        debug: JSON.stringify({ ...this.debug, existingOffer: this.existingOffer }),
        requestedUrl: window.location.href,
        offer_hash: this.params && this.params.hash,
        offer_vcId: this.params && this.params.vcId,
      });
    },
    async checkExisting(vcId, hash) {
      try {
        if (this.params.offerType_id && this.params.offerType_id !== 4) {
          const responseExisting = await axios.get(Config.GFU_API_URL + '/offers/by-vc-id/' + vcId) ||
            await axios.get(Config.GFU_API_URL + '/offers/by-hash/' + hash);
          this.existingOffer = responseExisting.data;
        } else {
          console.log('gere');
          const responseExisting = await axios.get(Config.GFU_API_URL + '/offers/by-hash/' + hash);
          this.existingOffer = responseExisting.data;
        }

      } catch (err) {
        console.log(err);
      }
    },
    prepareOffer() {
      this.offerClear();
      this.offerSet(this.params);
    },
    onSuccess() {
      this.clearHashParams();
      this.$router.push('/admin/offer-edit/' + this.offer.hash)
    },
    onError(err, defaultMsg) {
      this.errors = [
        ...this.errors,
        ...(err.response && err.response.data)
          ? err.response.data.map(({ message }) => message)
          : [defaultMsg ? defaultMsg : 'Das Angebot konnte aus unbekannten Gründen nicht erstellt werden.']
      ]
    },
    createOffer() {
      this.prepareOffer();
      this.saveOffer()
        .then(() => this.onSuccess())
        .catch((err) => this.onError(err))
    },
    createFromCopy() {
      this.prepareOffer();
      this.mergeOffers(this.existingOffer.hash)
        .then(() => this.onSuccess())
        .catch((err) => this.onError(err, 'Die Angebote konnten aus unbekannten Gründen nicht zusammengeführt werden.'));
    },
    overwriteFromCopy() {
      this.prepareOffer();
      this.overwriteOffer(this.existingOffer.hash)
        .then(() => this.onSuccess())
        .catch((err) => this.onError(err, 'Die Angebote konnten aus unbekannten Gründen nicht zusammengeführt werden.'));
    },
    resetOffer() {
      this.prepareOffer();
      this.overwriteOffer(this.existingOffer.hash)
        .then(() => this.onSuccess())
        .catch((err) => this.onError(err, 'Das Angebot konnte aus unbekannten Gründen nicht überschrieben werden.'))
    },
  },
  /**
   * If automatic redirect is desired, build this into 'paramsLoaded' after setting of 'this.existingOffer'
   *  */
  // async mounted () {
  //   if(this.errors.length === 0) {
  //   if(!this.existingOfferByVcId && !this.existingOfferByHash) { //if urlHash is valid
  //     this.createOffer();
  //   } 
  // }
  // }
}
</script>
